export const STORAGE_NAME = {
  CLIENT_LOG: 'CLIENT_LOG',
}
